// LICENSE_CODE ZON
'use strict'; /*jslint browser:true, es6:true, node:true, react:true*/
import React, {Fragment, useContext} from 'react';
import cn from 'classnames';
import {Settings_context} from '../../../../hola/pub/settings_ctx';
import Icon_star_filled from '../../img/icons/24/state_filled_small.svg';
import {Carusel} from '../../../../toolip/pub/ui/carusel';
import {Button} from '../../lib/button';
import {use_screen} from '../../../../hola/pub/lib/screen_util';
import {Trustpilot_widget} from '../content/trustpilot_widget';

import styles from './reviews.module.less';

const review_slides = [
    {
        name: 'Marcus',
        text: <Fragment>The customer experience was excellent. Very fast and
          prompt resolution when it comes to any issues and very attractive
          pricing. Returning customer!</Fragment>,
    },
    {
        name: 'Brady Whilden',
        text: <Fragment>Oculus has the best customer service and is always
          very helpful!</Fragment>,
    },
    {
        name: 'John Taylor',
        text: <Fragment>As a longtime customer of Oculus Proxies, they have
          been fast, affordable and reliable solutions for all of my proxies
          needs.</Fragment>,
    },
    {
        name: 'ceecee swims',
        text: <Fragment>Without a doubt the best proxy company on the market
          today. From customer service to quality, they have everything I
          need to help my company run to the max. Thanks oculus.</Fragment>,
    },
    {
        name: 'Noah Riven',
        text: <Fragment>I've been an avid customer of Oculus Proxies since
          2020 and they have never disappointed! They always cater to your
          needs and try to help whenever possible. The proxies have worked
          for me on all sites.</Fragment>,
    },
    {
        name: 'Glaze',
        text: <Fragment>Cheap and reliable proxies, been using it
          for 1-2 years and still one of the best proxies for sneakers
          on the market</Fragment>,
    },
];

const Stars = ()=>{
    return <div className={styles.stars}>
      {Array.from({length: 5}).map((_, i)=><Icon_star_filled key={i}/>)}
    </div>;
};

const Control = props=><Button color="tertiary" size="s"
  on_click={props.on_click} caption={props.children} icon_only
/>;

export const Reviews = ()=>{
    const {theme} = useContext(Settings_context);
    const {width} = use_screen();
    const slides = review_slides.map((item, index)=>{
        const item_cls = cn(styles.review, index % 2 == 0 && styles.shifted);
        return (
          <div key={index} className={item_cls}>
            <Stars />
            <p className={cn(theme.p14, styles.text)}>
              &ldquo;{item.text}&rdquo;
            </p>
            <p className={cn(theme.p14, styles.name)}>{item.name}</p>
          </div>
        );
    });
    const title_cls = cn(width < 768 ? theme.H2 : theme.H1, styles.title);
    return <section className={styles.reviews}>
      <div className={styles.bg}/>
      <div className={styles.container}>
        <p className={title_cls}>Our Customers Love Oculus</p>
        <Trustpilot_widget />
      </div>
      <Carusel items={slides} slide_width={320} slide_height={280}
        slides_gap={24} control_comp={Control}
        cls={{controls: styles.controls, root: styles.carousel}}/>
    </section>;
};
